import Navbar from './navbar';
import Panel from './panel';

const Sidebar = () => {
  return (
    <div id="sidebar" className="app-sidebar">
      <Navbar />
      <Panel />
    </div>
  );
};
export default Sidebar;
